import * as React from "react";
import PayPage from "./PayPage";


const Pay: React.FC = ()=>{
    return (<PayPage/>)
}

export default Pay